<template>
  <div class="animated">
    <v-client-table
      :columns="columns"
      :data="data"
      :options="options"
      :theme="theme"
      id="schedule-grinding-table"
      class="w-100"
    >
      <!-- <span slot="pid" slot-scope="{ row }">
        <router-link :to="'/samples/' + row.get('id')">
          {{ row.publicNumber() }}
        </router-link>
        <span>
          {{
            row.get("receiving_id") ? "(" + row.get("receiving_id") + ")" : null
          }}
        </span>
      </span>

      <span slot="identifier" slot-scope="{ row }">
        {{ row.get("identifier") }}
      </span>

      <span slot="actions" slot-scope="{ row }">
        <b-button
          v-if="row.get('receiving_id')"
          disabled
          variant="success"
          class="px-1 py-0 text-white"
          block
          @click="markReceived(row)"
        >
          <i class="fa fa-plus-circle"></i>
        </b-button>
        <b-button
          v-if="!row.get('receiving_id')"
          variant="success"
          class="px-1 py-0 text-white"
          block
          @click="markReceived(row)"
        >
          <i class="fa fa-plus-circle"></i>
        </b-button>
      </span> -->
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";

import InstrumentInstanceModel from "@/models/lab/InstrumentInstanceModel";
import ProcessScheduleModel from "@/models/lab/ProcessScheduleModel";

Vue.use(ClientTable);

let default_headings = {
  jig_index: "#",
  z: "Tray #",
  x: "Row #",
  y: "Position #",
  receiving_id: "Lab No.",
  n: "NO3-N",
  ph: "pH",
  ec: "EC",
  p: "P",
  k: "K",
  om: "OM",
  zn: "Zn",
  b: "B",
  texture: "Texture",
  cl: "Cl"
};

export default {
  name: "ScheduleGrindingTable",

  components: {
    ClientTable,
    Event
  },

  props: {
    process_schedule: {
      type: Object,
      default: () => null
    },
    instrument_instance: {
      type: Object,
      default: () => null
    },
    /** column include/display order array */
    show_columns: {
      type: Array,
      default: () => Object.keys(default_headings)
    },
    /** filterable column array */
    filterable: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      columns: this.show_columns,
      data: [],
      options: {
        headings: default_headings,
        sortable: [],
        filterable: this.filterable,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        },
        cellClasses: {
          n: [{ class: "bg-dark", condition: row => !row.n }],
          ph: [{ class: "bg-dark", condition: row => !row.ph }],
          ec: [{ class: "bg-dark", condition: row => !row.ec }],
          p: [{ class: "bg-dark", condition: row => !row.p }],
          k: [{ class: "bg-dark", condition: row => !row.k }],
          om: [{ class: "bg-dark", condition: row => !row.om }],
          zn: [{ class: "bg-dark", condition: row => !row.zn }],
          b: [{ class: "bg-dark", condition: row => !row.b }],
          texture: [{ class: "bg-dark", condition: row => !row.texture }],
          cl: [{ class: "bg-dark", condition: row => !row.cl }]
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  },

  methods: {
    populateGrindingOrder() {
      this.data = [];
      if (this.process_schedule && this.instrument_instance) {
        this.process_schedule
          .grindingOrder(this.instrument_instance.id)
          .then(({ response }) => {
            this.data = response.data;
          });
      }
    }
  },

  watch: {
    instrument_instance: {
      handler() {
        this.populateGrindingOrder();
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss">
#schedule-grinding-table {
  @media print {
    .bg-dark {
      background-color: #c8ced3 !important;
    }
  }
}
</style>
